import ApiService from "./apiservice";

export const AuthService = {
    login(_username, _password) {
        //encode to base64
        //_password = btoa(_password)

        const headers = {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
        
        const params = new URLSearchParams();
        params.append('username', _username);
        params.append('password', _password);

        //return ApiService.post("LoginPersonel", params, headers);
        return ApiService.post("NewLoginPersonel", params, null,headers);
    },
    TestConnection(){
        return ApiService.get("test");
    },
    TestPass(){
        return ApiService.get("login/TestPass");
    }
};